import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Small } from 'foundations-components/transitional/components/Small';
import { Flow } from 'signup-constants/Flow';
import { getIntegrationName } from '../utils/getIntegrationName';
import { isFlow } from '../utils/isFlow';
import { CustomTermsAndConditions, StyledPrivacyBanner } from './CustomTermsAndConditions';
import { usePrivacyBanner } from './usePrivacyBanner';
import { Text } from 'foundations-components/components/Text';
import { useTheme, isTrellisTheme } from 'foundations-theming/utils';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import PrivacyPolicy from './PrivacyPolicy';
import { jsx as _jsx } from "react/jsx-runtime";
const PrivacyBanner = ({
  PrivacyPolicyComponent = /*#__PURE__*/_jsx(PrivacyPolicy, {})
}) => {
  const theme = useTheme();
  const isTrellisThemeEnabled = isTrellisTheme(theme);
  const {
    isEmbedded
  } = useSignupEmbedder();
  const {
    shouldShowPrivacyBanner
  } = usePrivacyBanner();
  if (!shouldShowPrivacyBanner) {
    return null;
  }
  if (isFlow(Flow.Integrations)) {
    const integrationName = getIntegrationName();
    return integrationName ? /*#__PURE__*/_jsx(CustomTermsAndConditions, {
      PrivacyPolicy: PrivacyPolicyComponent,
      children: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "legal.integrationsLegalText",
        options: {
          integrationName
        }
      })
    }) : /*#__PURE__*/_jsx(Text, {
      as: "div",
      paddingInline: "400",
      textAlign: "center",
      children: /*#__PURE__*/_jsx(StyledPrivacyBanner, {
        "data-test-id": "legitimate-interest",
        children: /*#__PURE__*/_jsx(Small, {
          use: "help",
          children: PrivacyPolicyComponent
        })
      })
    });
  }
  return /*#__PURE__*/_jsx(Text, {
    as: "div",
    paddingInline: isTrellisThemeEnabled && isEmbedded ? '400' : undefined,
    textAlign: isTrellisThemeEnabled && !isEmbedded ? 'left' : 'center',
    children: /*#__PURE__*/_jsx(StyledPrivacyBanner, {
      "data-test-id": "legitimate-interest",
      children: /*#__PURE__*/_jsx(Small, {
        use: "help",
        children: PrivacyPolicyComponent
      })
    })
  });
};
export default PrivacyBanner;